<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_7550_5936)">
        <rect x="1" y="1" width="2" height="4" fill="var(--icon-color)" />
        <rect x="5" y="1" width="2" height="4" transform="rotate(90 5 1)" fill="var(--icon-color)" />
        <rect x="12" y="7" width="2" height="8" transform="rotate(90 12 7)" fill="var(--icon-color)" />
        <rect x="14" y="1" width="2" height="3" transform="rotate(90 14 1)" fill="var(--icon-color)" />
        <rect x="1" y="11" width="2" height="4" fill="var(--icon-color)" />
        <rect x="5" y="13" width="2" height="3" transform="rotate(90 5 13)" fill="var(--icon-color)" />
        <rect x="14" y="13" width="2" height="4" transform="rotate(90 14 13)" fill="var(--icon-color)" />
        <rect x="13" y="1" width="2" height="4" fill="var(--icon-color)" />
        <rect x="13" y="11" width="2" height="4" fill="var(--icon-color)" />
    </g>
    <defs>
        <clipPath id="clip0_7550_5936">
            <rect width="16" height="16" fill="var(--bg-color)" />
        </clipPath>
    </defs>
</svg>
